<p-sidebar #sidebarRef [(visible)]="isSidebarOpen">
    <ng-template pTemplate="headless">
        <div class="flex flex-column h-full">
            <div class="overflow-y-auto">
                <ul class="list-none p-3 m-0">
                    @for (item of model; track item.label) {
                        <app-sidebar-item [item]="item"></app-sidebar-item>
                    }
                </ul>
            </div>
            <div class="mt-auto">
                <hr class="mb-3 mx-3 border-top-1 border-none surface-border" />
                <a pRipple
                    class="m-3 flex align-items-center cursor-pointer p-3 gap-2 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
                    <p-avatar image="https://primefaces.org/cdn/primeng/images/demo/avatar/amyelsner.png"
                        shape="circle" />
                    <span class="font-bold">Amy Elsner</span>
                </a>
            </div>
        </div>
    </ng-template>
</p-sidebar>